import pickBy from "lodash-es/pickBy";

import { isDefined } from "@mapmycustomers/shared/util/assert";

const removeUndefinedFields = <T extends object>(object: T): Partial<T> =>
  pickBy(object, isDefined);

export default removeUndefinedFields;
